import styled from '@emotion/styled';
import CoreButton from '@shared/components/core/button/CoreButton';
import { CardMedium, IconWrap } from '@shared/components/core/card/CommonCardStyles';
import { BodySmall, TitleSmall } from '@shared/components/core/text/Typography';
import LicenseTypeLogo from '@shared/components/license/LicenseTypeLogo';
import { getLicenseType } from '@shared/constants/organization/LicenseUtils';
import OrganizationPrivateProductModel from '@shared/models/organizations/OrganizationPrivateProductModel';
import { useTranslation } from 'react-i18next';

export interface IOrgProductCardProps {
    orgProduct: OrganizationPrivateProductModel;
}

export default function OrgProductCard({ orgProduct }: IOrgProductCardProps) {
    const { t } = useTranslation();
    const match = orgProduct.product.billingCycle && orgProduct.product.billingCycle.match(/(\d+)\.\d{2}:\d{2}:\d{2}/);
    const days = match ? parseInt(match[1]) : null;
    const years = days ? Math.floor(days / 365) : null;

    return (
        <StyledCardMedium>
            <StyledIconWrap>
                <LicenseTypeLogo licenseType={getLicenseType(orgProduct.product)} size={200} />
            </StyledIconWrap>

            <TitleSmall>{orgProduct.product.name}</TitleSmall>
            <BodySmall>{t(`common:license.key.product.${orgProduct.product.billingType}.title`)}</BodySmall>
            {years && years == 1 && <BodySmall>{t('common:license.key.product.yearly')}</BodySmall>}
            {years && years > 1 && <BodySmall>{t('common:license.key.product.years', { value: years })}</BodySmall>}
            {days && !years && <BodySmall>{t('common:license.key.product.days', { value: days })}</BodySmall>}
            <BodySmall>{orgProduct.product.description}</BodySmall>

            <CoreButton
                to={`/org/${orgProduct.organizationId}/product/${orgProduct.productId}`}
                $color="subsection"
                endIcon="externalLink">
                {t('common:license.key.product.titleLong')}
            </CoreButton>
        </StyledCardMedium>
    );
}

const StyledIconWrap = styled(IconWrap)`
    padding: 0 0;
    min-height: auto;
    align-items: flex-start;
`;

const StyledCardMedium = styled(CardMedium)`
    align-items: flex-start;
    max-height: fit-content;
`;
